import { Navigate, Route } from 'react-router-dom';
import { UserGuidePage } from './pages/UserGuide/UserGuidePage';
import { BanksPage } from './pages/Banks/BanksPage';
import { BankAccountsPage } from './pages/BankAccounts/BankAccountsPage';
import { FundsPage } from './pages/Funds/FundsPage';
import { ISAAssetTypesPage } from './pages/ISAAssetTypes/ISAAssetTypesPage';
import { ISASecurityIdTypesPage } from './pages/ISASecurityIdTypes/ISASecurityIdTypesPage';
import { TradeMarketsPage } from './pages/TradeMarkets/TradeMarketsPage';
import { TradePlacesPage } from './pages/TradePlaces/TradePlacesPage';
import { IsaCreditRiskTypesPage } from './pages/IsaCreditRiskTypes/IsaCreditRiskTypesPage';
import { TradePlacesBloombergPage } from './pages/TradePlacesBloomberg/TradePlacesBloombergPage';
import { RatingCompaniesPage } from './pages/RatingCompanies/RatingCompaniesPage';
import { CreditRiskTypesPage } from './pages/CreditRiskTypes/CreditRiskTypesPage';
import { CreditSourceGroupsPage } from './pages/CreditSourceGroups/CreditSourceGroupsPage';
import { CreditSourceGroupMapPage } from './pages/CreditSourceGroupMap/CreditSourceGroupMapPage';
import { CategoryMapPage } from './pages/CategoryMap/CategoryMapPage';
import { TrusteesPage } from './pages/Trustees/TrusteesPage';
import { BaseAssetTypesPage } from './pages/BaseAssetTypes/BaseAssetTypesPage';
import { AssetTypeDefaultValuesPage } from './pages/AssetTypeDefaultValues/AssetTypeDefaultValuesPage';
import { IndustryGroupsPage } from './pages/IndustryGroups/IndustryGroupsPage';
import { IndustrySectorsPage } from './pages/IndustrySectors/IndustrySectorsPage';
import { InventoryRowTypesPage } from './pages/InventoryRowTypes/InventoryRowTypesPage';
import { SwapKosherFundsPage } from './pages/SwapKosherFunds/SwapKosherFundsPage';
import { AccountPurposesPage } from './pages/AccountPurposes/AccountPurposesPage';
import { AccountLendingTypesPage } from './pages/AccountLendingTypes/AccountLendingTypesPage';
import { SwapStatusesPage } from './pages/SwapStatuses/SwapStatusesPage';
import { SwapInterestTypesPage } from './pages/SwapInterestTypes/SwapInterestTypesPage';
import { RatingScalePage } from './pages/RatingScale/RatingScalePage';
import { RatingLevelsPage } from './pages/RatingLevels/RatingLevelsPage';
import { FundClassificationsPage } from './pages/FundClassifications/FundClassificationsPage';
import { CompaniesPage } from './pages/Companies/CompaniesPage';
import { RelatedIssuersPage } from './pages/RelatedIssuers/RelatedIssuersPage';
import { ProspectusExposureTypesPage } from './pages/ProspectusExposureTypes/ProspectusExposureTypesPage';
import { ProspectusExtraDetailsPage } from './pages/ProspectusExtraDetails/ProspectusExtraDetailsPage';
import { OperatorsPage } from './pages/Operators/OperatorsPage';
import { IsaFundClassificationsPage } from './pages/IsaFundClassifications/IsaFundClassificationsPage';
import { ContinentsPage } from './pages/Continents/ContinentsPage';
import { CountriesPage } from './pages/Countries/CountriesPage';
import { AssetTypesPage } from './pages/AssetTypes/AssetTypesPage';
import { SourcesPage } from './pages/Sources/SourcesPage';
import { LendingFeeCalcTypesPage } from './pages/LendingFeeCalcTypes/LendingFeeCalcTypesPage';
import { IssuersPage } from './pages/Issuers/IssuersPage';
import { BenchmarkRatesPage } from './pages/BenchmarkRates/BenchmarkRatesPage';
import { BenchmarkRatePeriodsPage } from './pages/BenchmarkRatePeriods/BenchmarkRatePeriodsPage';
import { BFIXSpecialDaysPage } from './pages/BFIXSpecialDays/BFIXSpecialDaysPage';
import { BFIXRateTypesPage } from './pages/BFIXRateTypes/BFIXRateTypesPage';
import { AssetsPage } from './pages/Assets/AssetsPage';
import { AssetRecordPage } from './pages/AssetForm/AssetRecordPage';
import { FundRecordPage } from './pages/FundForm/FundRecordPage';
import { CategoriesPage } from './pages/Categories/CategoriesPage';
import { CurrencyNonSettlementDatesPage } from './pages/CurrencyNonSettlementDates/CurrencyNonSettlementDatesPage';
import { CrcyPage } from './pages/Crcy/CrcyPage';
import { IdxPage } from './pages/Idx/IdxPage';
import { GenericImportPage } from './pages/GenericImport/GenericImportPage';
import { BankFilesPage } from './pages/BankFiles/BankFilesPage';
import { ForeignContractsPage } from './pages/ForeignContracts/ForeignContractsPage';
import { BankImportsAdminPage } from './pages/BankImportsAdmin/BankImportsAdminPage';
import { BankImportLogPage } from './pages/BankImportLog/BankImportLogPage';
import { PreInventoryTablePage } from './pages/PreInventoryTable/PreInventoryTablePage';
import { InventoryPage } from './pages/Inventory/InventoryPage';
import { LendingsPage } from './pages/Lendings/LendingsPage';
import { SwapUfPage } from './pages/SwapUf/SwapUfPage';
import { LegacyRatesImportPage } from './pages/LegacyRatesImport/LegacyRatesImportPage';
import { HoldingsPage } from './pages/Holdings/HoldingsPage';
import { FundDataHistoryPage } from './pages/FundDataHistory/FundDataHistoryPage';
import { OptionsBlackScholesPage } from './pages/OptionsBlackScholes/OptionsBlackScholesPage';
import { CalcTypesPage } from './pages/CalcTypes/CalcTypesPage';
import { CalcMethodsPage } from './pages/CalcMethods/CalcMethodsPage';
import { CalcMethodMapPage } from './pages/CalcMethodMap/CalcMethodMapPage';
import { BalanceTypesPage } from './pages/BalanceTypes/BalanceTypesPage';
import { PriceTypesPage } from './pages/PriceTypes/PriceTypesPage';
import { ConfigQuantoPage } from './pages/ConfigQuanto/ConfigQuantoPage';
import { NonQuantoDaysPage } from './pages/NonQuantoDays/NonQuantoDaysPage';
import { NonDmf4FundPage } from './pages/NonDmf4Fund/NonDmf4FundPage';
import { NonTradingDays4FundPage } from './pages/NonTradingDays4Fund/NonTradingDays4FundPage';
import { CapitalConsolidationsPage } from './pages/CapitalConsolidations/CapitalConsolidationsPage';
import { ForwardInterestSettingsPage } from './pages/ForwardInterestSettings/ForwardInterestSettingsPage';
import { SpecialCreationLimitsPage } from './pages/SpecialCreationLimits/SpecialCreationLimitsPage';
import { ManualBalancesPage } from './pages/ManualBalances/ManualBalancesPage';
import { CreationRedemptionsPage } from './pages/CreationRedemptions/CreationRedemptionsPage';
import { AgendaActionsPage } from './pages/Agenda/AgendaActionsPage';
import { AgendaDailyPage } from './pages/Agenda/AgendaDailyPage';
import { AgendaCategoriesPage } from './pages/Agenda/AgendaCategoriesPage';
import { ValuationTypesPage } from './pages/Agenda/ValuationTypesPage';
import { SpecialRatesGeneralPage } from './pages/SpecialRates/SpecialRatesGeneralPage';
import { SpecialRatesTenantPage } from './pages/SpecialRates/SpecialRatesTenantPage';
import { SpecialRatesEffectivePage } from './pages/SpecialRates/SpecialRatesEffectivePage';
import { AlertsDashboardPage } from './pages/Alerts/AlertsDashboardPage';
import { AlertTypesPage } from './pages/AlertTypes/AlertTypesPage';
import { SysadminToolsPage } from './pages/SysadminTools/SysadminToolsPage';
import { RatesPage } from './pages/Rates/RatesPage';
import { RatesHistoryPage } from './pages/RatesHistory/RatesHistoryPage';
import { IdxRatesPage } from './pages/IdxRates/IdxRatesPage';
import { IdxRatesHistoryPage } from './pages/IdxRatesHistory/IdxRatesHistoryPage';
import { IdxCompositionsPage } from './pages/IdxCompositions/IdxCompositionsPage';
import { IdxCompositionsHistoryPage } from './pages/IdxCompositionsHistory/IdxCompositionsHistoryPage';
import { TaseIdxCompositionsPage } from './pages/TaseIdxCompositions/TaseIdxCompositionsPage';
import { PublishedFundRatesPage } from './pages/PublishedFundRates/PublishedFundRatesPage';
import { DisclosureLevel1Page } from './pages/DisclosureLevel1/DisclosureLevel1Page';
import { DisclosureLevel2Page } from './pages/DisclosureLevel2/DisclosureLevel2Page';
import { DisclosureLevel3Page } from './pages/DisclosureLevel3/DisclosureLevel3Page';
import { DisclosureLevel4Page } from './pages/DisclosureLevel4/DisclosureLevel4Page';
import { DashboardPage } from './pages/Dashboard/DashboardPage';
import { UsersPage } from './pages/Admin/UsersPage';
import { RolesPage } from './pages/Admin/RolesPage';
import { RolePermissionsPage } from './pages/Admin/RolePermissionsPage';
import { AssistantLogPage } from './pages/AssistantLog/AssistantLogPage';
import { AuditLogPage } from './pages/AuditLog/AuditLogPage';
import { PageViewLogPage } from './pages/PageViewLog/PageViewLogPage';
import { DayOpenPage } from './pages/DayOpen/DayOpenPage';
import { ParseFilesPage } from './pages/DevTools/ParseFilesPage';

// Route elements shared by every keep-alive tab pane. Extracted out of
// App.tsx (decision: internal-tabs plan §3.3) so each <TabHost> pane can
// render its own <Routes location={tab.location}>{appRoutes}</Routes>
// against a per-tab frozen location, instead of the router's single active
// location. Do not add route registration logic here beyond plain <Route>
// elements — this file is pure route data.
export const appRoutes = (
  <>
    <Route index element={<DashboardPage />} />
              <Route path="/settings/banks" element={<BanksPage />} />
              <Route path="/settings/funds" element={<FundsPage />} />
              <Route path="/fund-form" element={<FundRecordPage />} />
              <Route path="/settings/bank-accounts" element={<BankAccountsPage />} />
              <Route path="/isa-asset-types" element={<ISAAssetTypesPage />} />
              <Route path="/isa-security-id-types" element={<ISASecurityIdTypesPage />} />
              <Route path="/trade-markets" element={<TradeMarketsPage />} />
              <Route path="/trade-places" element={<TradePlacesPage />} />
              <Route path="/isa-credit-risk-types" element={<IsaCreditRiskTypesPage />} />
              <Route path="/trade-places-bloomberg" element={<TradePlacesBloombergPage />} />
              <Route path="/rating-companies" element={<RatingCompaniesPage />} />
              <Route path="/credit-risk-types" element={<CreditRiskTypesPage />} />
              <Route path="/credit-source-groups" element={<CreditSourceGroupsPage />} />
              <Route path="/credit-source-group-map" element={<CreditSourceGroupMapPage />} />
              <Route path="/category-map" element={<CategoryMapPage />} />
              <Route path="/trustees" element={<TrusteesPage />} />
              <Route path="/base-asset-types" element={<BaseAssetTypesPage />} />
              <Route path="/asset-type-default-values" element={<AssetTypeDefaultValuesPage />} />
              <Route path="/industry-groups" element={<IndustryGroupsPage />} />
              <Route path="/industry-sectors" element={<IndustrySectorsPage />} />
              <Route path="/inventory-row-types" element={<InventoryRowTypesPage />} />
              <Route path="/swap-kosher-funds" element={<SwapKosherFundsPage />} />
              <Route path="/account-purposes" element={<AccountPurposesPage />} />
              <Route path="/account-lending-types" element={<AccountLendingTypesPage />} />
              <Route path="/swap-statuses" element={<SwapStatusesPage />} />
              <Route path="/swap-interest-types" element={<SwapInterestTypesPage />} />
              <Route path="/rating-scale" element={<RatingScalePage />} />
              <Route path="/rating-levels" element={<RatingLevelsPage />} />
              <Route path="/fund-classifications" element={<FundClassificationsPage />} />
              <Route path="/companies" element={<CompaniesPage />} />
              <Route path="/related-issuers" element={<RelatedIssuersPage />} />
              <Route path="/prospectus-exposure-types" element={<ProspectusExposureTypesPage />} />
              <Route path="/prospectus-extra-details" element={<ProspectusExtraDetailsPage />} />
              <Route path="/operators" element={<OperatorsPage />} />
              <Route path="/isa-fund-classifications" element={<IsaFundClassificationsPage />} />
              <Route path="/continents" element={<ContinentsPage />} />
              <Route path="/countries" element={<CountriesPage />} />
              <Route path="/asset-types" element={<AssetTypesPage />} />
              <Route path="/sources" element={<SourcesPage />} />
              <Route
                path="/lending-fee-calc-types"
                element={<LendingFeeCalcTypesPage />}
              />
              <Route path="/issuers" element={<IssuersPage />} />
              <Route path="/benchmark-rates" element={<BenchmarkRatesPage />} />
              <Route path="/benchmark-rate-periods" element={<BenchmarkRatePeriodsPage />} />
              <Route path="/bfix-special-days" element={<BFIXSpecialDaysPage />} />
              <Route path="/bfix-rate-types" element={<BFIXRateTypesPage />} />
              <Route path="/assets" element={<AssetsPage />} />
              <Route path="/asset-form" element={<AssetRecordPage />} />
              <Route path="/categories" element={<CategoriesPage />} />
              <Route
                path="/currency-non-settlement-dates"
                element={<CurrencyNonSettlementDatesPage />}
              />
              <Route path="/crcy" element={<CrcyPage />} />
              <Route path="/idx" element={<IdxPage />} />
              <Route path="/generic-import" element={<GenericImportPage />} />
              <Route path="/bank-files" element={<BankFilesPage />} />
              <Route path="/foreign-contracts" element={<ForeignContractsPage />} />
              <Route path="/bank-imports-admin" element={<BankImportsAdminPage />} />
              <Route path="/bank-import-log" element={<BankImportLogPage />} />
              <Route path="/pre-inventory-table" element={<PreInventoryTablePage />} />
              <Route path="/inventory" element={<InventoryPage />} />
            <Route path="/lendings" element={<LendingsPage />} />
              <Route path="/swap-uf" element={<SwapUfPage />} />
              <Route path="/legacy-rates-import" element={<LegacyRatesImportPage />} />
              <Route path="/day-open" element={<DayOpenPage />} />
              <Route path="/holdings" element={<HoldingsPage />} />
              <Route path="/fund-data-history" element={<FundDataHistoryPage />} />
              <Route path="/options-black-scholes" element={<OptionsBlackScholesPage />} />
              <Route path="/calc-types" element={<CalcTypesPage />} />
              <Route path="/calc-methods" element={<CalcMethodsPage />} />
              <Route path="/calc-method-map" element={<CalcMethodMapPage />} />
              <Route path="/balance-types" element={<BalanceTypesPage />} />
              <Route path="/price-types" element={<PriceTypesPage />} />
              <Route path="/config-quanto" element={<ConfigQuantoPage />} />
              <Route path="/non-quanto-days" element={<NonQuantoDaysPage />} />
              <Route path="/non-dmf-4-fund" element={<NonDmf4FundPage />} />
              <Route
                path="/non-trading-days-4-fund"
                element={<NonTradingDays4FundPage />}
              />
              <Route
                path="/capital-consolidations"
                element={<CapitalConsolidationsPage />}
              />
              <Route
                path="/forward-interest-settings"
                element={<ForwardInterestSettingsPage />}
              />
              <Route
                path="/special-creation-limits"
                element={<SpecialCreationLimitsPage />}
              />
              <Route
                path="/creation-redemptions"
                element={<CreationRedemptionsPage />}
              />
              <Route
                path="/manual-balances-4-valuation"
                element={<ManualBalancesPage />}
              />
              <Route path="/agenda" element={<AgendaDailyPage />} />
              <Route path="/agenda-actions" element={<AgendaActionsPage />} />
              <Route path="/agenda-categories" element={<AgendaCategoriesPage />} />
              <Route path="/valuation-types" element={<ValuationTypesPage />} />
              <Route path="/special-rates-general" element={<SpecialRatesGeneralPage />} />
              <Route path="/special-rates" element={<SpecialRatesTenantPage />} />
              <Route path="/special-rates-effective" element={<SpecialRatesEffectivePage />} />
              <Route path="/alerts" element={<AlertsDashboardPage />} />
              <Route path="/alert-types" element={<AlertTypesPage />} />
              <Route path="/sysadmin-tools" element={<SysadminToolsPage />} />
              <Route path="/rates" element={<RatesPage />} />
              <Route path="/rates-history" element={<RatesHistoryPage />} />
              <Route path="/idx-rates" element={<IdxRatesPage />} />
              <Route path="/idx-rates-history" element={<IdxRatesHistoryPage />} />
              <Route path="/idx-compositions" element={<IdxCompositionsPage />} />
              <Route
                path="/idx-compositions-history"
                element={<IdxCompositionsHistoryPage />}
              />
              <Route
                path="/tase-idx-compositions"
                element={<TaseIdxCompositionsPage />}
              />
              <Route
                path="/published-fund-rates"
                element={<PublishedFundRatesPage />}
              />
              <Route path="/disclosure-level-1" element={<DisclosureLevel1Page />} />
              <Route path="/disclosure-level-2" element={<DisclosureLevel2Page />} />
              <Route path="/disclosure-level-3" element={<DisclosureLevel3Page />} />
              <Route path="/disclosure-level-4" element={<DisclosureLevel4Page />} />
              <Route path="/assistant-log" element={<AssistantLogPage />} />
              <Route path="/audit-log" element={<AuditLogPage />} />
              <Route path="/page-view-log" element={<PageViewLogPage />} />
              <Route path="/admin/users" element={<UsersPage />} />
              <Route path="/admin/roles" element={<RolesPage />} />
              <Route
                path="/settings/role-permissions"
                element={<RolePermissionsPage />}
              />
              <Route path="/dev-tools/parse-files" element={<ParseFilesPage />} />
              <Route path="/user-guide" element={<UserGuidePage />} />
    <Route path="*" element={<Navigate to="/" replace />} />
  </>
);
